// src/services/api.js
import axios from 'axios';
import config from '../config.js'

const api = axios.create({
    baseURL: config.API_BASE,
  });
  
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // console.log(`[API Request] ${config.method?.toUpperCase()} ${config.url}`);
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;